(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-clean-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-clean-header-v2')) {
    customElements.define('kr-clean-header-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.toggleButton = this.querySelector('.krh__toggle');
        this.nav = this.querySelector('.krh__nav');
        this.cartLink = this.querySelector('.krh__cart');
        this.setAttribute('data-ready', '');
        const updateHeight = () => {
          if (!this.hasAttribute('data-open') || window.matchMedia('(min-width:1200px)').matches) {
            const height = Math.ceil(this.getBoundingClientRect().height);
            if (height > 0) this.style.setProperty('--krh-collapsed-height', height + 'px');
          }
        };
        this.sizeObserver = new ResizeObserver(updateHeight);
        this.sizeObserver.observe(this);
        updateHeight();
        const close = (restoreFocus = false) => {
          this.removeAttribute('data-open');
          this.toggleButton?.setAttribute('aria-expanded', 'false');
          this.querySelectorAll('details[open]').forEach(item => item.open = false);
          if (restoreFocus) this.toggleButton?.focus();
        };
        this.toggleButton?.addEventListener('click', () => {
          const open = !this.hasAttribute('data-open');
          this.toggleAttribute('data-open', open);
          this.toggleButton.setAttribute('aria-expanded', String(open));
          if (!open) close();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const dropdown = event.target.closest('details[open]');
          if (dropdown) {
            dropdown.open = false;
            dropdown.querySelector('summary').focus();
          } else close(this.hasAttribute('data-open'));
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) close();
        }, { signal });
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
        }, { signal });
        this.nav?.addEventListener('click', event => {
          if (event.target.closest('a')) close();
        }, { signal });
        // KR-20260907-CART-RESTORE-14 START: follow the theme's native section-rendered counter.
        const syncCartLabel = () => {
          const badge = this.cartLink.querySelector('[data-render-cart-bubble]');
          const count = Number.parseInt(badge?.textContent, 10);
          if (Number.isInteger(count)) {
            this.cartLink.setAttribute('aria-label', this.dataset.cartLabel.replace('__COUNT__', String(count)));
          }
        };
        this.cartObserver = new MutationObserver(syncCartLabel);
        this.cartObserver.observe(this.cartLink, { childList:true, subtree:true, characterData:true });
        syncCartLabel();
        // KR-20260907-CART-RESTORE-14 END
        const refresh = async () => {
          if (this.loading || document.hidden) return;
          this.loading = true;
          try {
            const response = await fetch(this.dataset.cartUrl, { signal, credentials:'same-origin', cache:'no-store' });
            if (!response.ok) return;
            const cart = await response.json();
            if (!Number.isInteger(cart.item_count)) return;
            this.cartLink.setAttribute('aria-label', this.dataset.cartLabel.replace('__COUNT__', String(cart.item_count)));
            // KR-20260907-CART-RESTORE-14 START
            const badge = this.cartLink.querySelector('[data-render-cart-bubble]');
            if (badge) {
              badge.textContent = String(cart.item_count);
              badge.classList.toggle('hidden', cart.item_count === 0);
            }
            // KR-20260907-CART-RESTORE-14 END
          } catch {} finally { this.loading = false; }
        };
        ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, refresh, { signal }));
        window.addEventListener('pageshow', refresh, { signal });
        window.addEventListener('focus', refresh, { signal });
        this.cartLink.addEventListener('pointerenter', refresh, { signal });
        this.cartLink.addEventListener('focus', refresh, { signal });
      }
      disconnectedCallback() {
        this.sizeObserver?.disconnect();
        // KR-20260907-CART-RESTORE-14 START
        this.cartObserver?.disconnect();
        // KR-20260907-CART-RESTORE-14 END
        this.controller?.abort();
        this.controller = null;
        this.loading = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-cmf-quality"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-cmf-editorial-carousel')) {
    customElements.define(
      'kr-cmf-editorial-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;

          const init = () => {
            if (!this.isConnected) return;

            this.track = this.querySelector('[data-cmf-track]');
            this.cards = Array.from(
              this.querySelectorAll('[data-cmf-card]')
            );
            this.nav = this.querySelector('[data-cmf-nav]');
            this.prev = this.querySelector('[data-cmf-prev]');
            this.next = this.querySelector('[data-cmf-next]');

            if (
              !this.track ||
              !this.cards.length ||
              !this.prev ||
              !this.next
            ) return;

            this.requestedLeft = null;

            this.prev.addEventListener('click', () => {
              this.step(-1);
            }, { signal });

            this.next.addEventListener('click', () => {
              this.step(1);
            }, { signal });

            this.track.addEventListener('scroll', () => {
              this.requestUpdate();

              clearTimeout(this.settleTimer);

              this.settleTimer = setTimeout(() => {
                this.requestedLeft = null;
                this.update();
              }, 180);
            }, { passive: true, signal });

            this.track.addEventListener('scrollend', () => {
              clearTimeout(this.settleTimer);
              this.requestedLeft = null;
              this.update();
            }, { signal });

            const clearRequestedPosition = () => {
              this.requestedLeft = null;
            };

            this.track.addEventListener(
              'pointerdown',
              clearRequestedPosition,
              { passive: true, signal }
            );

            this.track.addEventListener(
              'wheel',
              clearRequestedPosition,
              { passive: true, signal }
            );

            this.track.addEventListener('keydown', event => {
              if (event.target !== this.track) return;

              if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.step(1);
              } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.step(-1);
              } else if (event.key === 'Home') {
                event.preventDefault();
                this.go(0);
              } else if (event.key === 'End') {
                event.preventDefault();
                this.go(this.maxScroll());
              }
            }, { signal });

            window.addEventListener('resize', () => {
              this.requestedLeft = null;
              this.requestUpdate();
            }, { signal });

            if ('ResizeObserver' in window) {
              this.observer = new ResizeObserver(() => {
                this.requestedLeft = null;
                this.requestUpdate();
              });

              this.observer.observe(this.track);

              this.cards.forEach(card => {
                this.observer.observe(card);
              });
            }

            document.addEventListener(
              'shopify:block:select',
              event => {
                const blockId = String(
                  event.detail?.blockId || ''
                );

                const card = this.cards.find(node =>
                  node.dataset.blockId === blockId
                );

                if (!card) return;

                this.go(this.cardPosition(card), true);
              },
              { signal }
            );

            this.update();
          };

          if (document.readyState === 'loading') {
            document.addEventListener(
              'DOMContentLoaded',
              init,
              { once: true, signal }
            );
          } else {
            init();
          }
        }

        maxScroll() {
          return Math.max(
            0,
            this.track.scrollWidth - this.track.clientWidth
          );
        }

        cardPosition(card) {
          const cardRect = card.getBoundingClientRect();
          const trackRect = this.track.getBoundingClientRect();

          return this.track.scrollLeft +
            cardRect.left -
            trackRect.left -
            this.track.clientLeft;
        }

        requestUpdate() {
          cancelAnimationFrame(this.updateFrame);

          this.updateFrame = requestAnimationFrame(() => {
            if (this.isConnected) this.update();
          });
        }

        step(direction) {
          const max = this.maxScroll();
          const epsilon = 2;

          if (max <= epsilon) return;

          const current = Math.max(
            0,
            Math.min(
              max,
              this.requestedLeft ?? this.track.scrollLeft
            )
          );

          const stops = Array.from(new Set([
            0,
            ...this.cards.map(card =>
              Math.max(
                0,
                Math.min(max, this.cardPosition(card))
              )
            ),
            max
          ])).sort((a, b) => a - b);

          let target;

          if (direction > 0) {
            target = stops.find(
              stop => stop > current + epsilon
            );

            if (target === undefined) target = max;
          } else {
            target = stops.slice().reverse().find(
              stop => stop < current - epsilon
            );

            if (target === undefined) target = 0;
          }

          this.go(target);
        }

        go(left, instant = false) {
          const target = Math.max(
            0,
            Math.min(this.maxScroll(), left)
          );

          const reduced = matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          this.requestedLeft = target;

          this.track.scrollTo({
            left: target,
            behavior: instant || reduced ? 'instant' : 'smooth'
          });

          this.requestUpdate();
        }

        update() {
          if (!this.track || !this.prev || !this.next) return;

          const max = this.maxScroll();
          const epsilon = 2;

          const current = Math.max(
            0,
            Math.min(max, this.track.scrollLeft)
          );

          const atStart = current <= epsilon;
          const atEnd = current >= max - epsilon;

          if (this.nav) {
            this.nav.hidden = max <= epsilon;
          }

          this.prev.disabled = atStart;
          this.next.disabled = atEnd;

          this.prev.setAttribute(
            'aria-disabled',
            String(atStart)
          );

          this.next.setAttribute(
            'aria-disabled',
            String(atEnd)
          );
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.updateFrame);
          clearTimeout(this.settleTimer);

          this.controller?.abort();
          this.observer?.disconnect();

          this.controller = null;
          this.requestedLeft = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-r1-applications"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-applications-v2')) {
    customElements.define('kr-applications-v2', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.controller?.abort();
        this.controller = new AbortController();

        const signal = this.controller.signal;
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');

        const syncMotion = () => {
          const enabled =
            !this.preference.matches &&
            !window.Shopify?.designMode;

          this.dataset.motion = String(enabled);

          this.querySelectorAll('.kr-applications__viewport')
            .forEach(viewport => {
              viewport.scrollLeft = 0;
            });
        };

        this.preference.addEventListener(
          'change',
          syncMotion,
          { signal }
        );

        const syncVisibility = () => {
          this.dataset.hidden = String(document.hidden);
        };

        document.addEventListener(
          'visibilitychange',
          syncVisibility,
          { signal }
        );

        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.kr-applications__card');
          if (!card) return;

          const viewport = card.closest('.kr-applications__viewport');
          if (!viewport) return;

          viewport.scrollTo({
            left:
              viewport.scrollLeft +
              card.getBoundingClientRect().left -
              viewport.getBoundingClientRect().left,
            behavior: 'instant'
          });
        }, { signal });

        syncMotion();
        syncVisibility();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-r1-training-progress"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-training-videos')) {
    customElements.define('kr-training-videos', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.track = this.querySelector('.kr-training__track');
        this.viewport = this.querySelector('.kr-training__viewport');
        this.nav = this.querySelector('.kr-training__nav');
        this.prev = this.querySelector('[data-training-prev]');
        this.next = this.querySelector('[data-training-next]');

        if (!this.track || !this.viewport) return;

        this.track.querySelectorAll('[data-training-clone]').forEach(node => node.remove());

        this.cards = Array.from(
          this.track.querySelectorAll('[data-training-card]')
        );

        this.count = this.cards.length;
        this.index = 0;
        this.queue = [];
        this.userPaused = new Set();
        this.manualStarted = new Set();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        this.inView = !('IntersectionObserver' in window);
        this.jumping = false;
        this.moving = false;
        this.dragging = false;

        const signal = this.controller.signal;

        if (this.nav) this.nav.hidden = this.count < 2;
        if (!this.count) return;

        this.prev?.addEventListener('click', () => this.step(-1), { signal });
        this.next?.addEventListener('click', () => this.step(1), { signal });

        this.track.addEventListener('scroll', () => {
          if (!this.jumping && !this.dragging) this.scheduleFinish(140);
        }, { passive: true, signal });

        this.track.addEventListener('scrollend', () => {
          if (!this.jumping && !this.dragging) this.finish();
        }, { signal });

        this.track.addEventListener('pointerdown', event => {
          if (event.target.closest('[data-training-play]')) return;

          this.dragging = true;
          this.moving = false;
          this.targetPhysical = null;
          this.queue = [];
          clearTimeout(this.scrollTimer);

          this.track.scrollTo({
            left: this.track.scrollLeft,
            behavior: 'instant'
          });

          this.pauseVideos();
        }, { passive: true, signal });

        const release = () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.scheduleFinish(160);
        };

        window.addEventListener('pointerup', release, { passive: true, signal });
        window.addEventListener('pointercancel', release, { passive: true, signal });

        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;

          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.count - 1);
          }
        }, { signal });

        this.cards.forEach((card, index) => {
          const video = card.querySelector('video');
          const button = card.querySelector('[data-training-play]');

          if (!video) return;

          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;

          video.addEventListener('playing', () => {
            if (index !== this.index || !this.inView || document.hidden) {
              video.pause();
              return;
            }

            card.classList.add('is-playing');
            this.updateButton(card);
          }, { signal });

          video.addEventListener('pause', () => {
            card.classList.remove('is-playing');
            this.updateButton(card);
          }, { signal });

          video.addEventListener('error', () => {
            card.classList.remove('is-playing');
            this.updateButton(card);
          }, { signal });

          button?.addEventListener('click', () => {
            if (index !== this.index) return;

            if (video.paused) {
              this.userPaused.delete(index);
              this.manualStarted.add(index);
            } else {
              this.userPaused.add(index);
            }

            this.syncVideos();
          }, { signal });
        });

        document.addEventListener('visibilitychange', () => {
          this.syncVideos();
        }, { signal });

        document.addEventListener('shopify:block:select', event => {
          let card = event.target.closest?.('[data-training-card]');

          if (!card && event.detail?.blockId) {
            card = this.cards.find(node =>
              node.dataset.trainingBlock === String(event.detail.blockId)
            );
          }

          if (!card || !this.cards.includes(card)) return;

          this.goTo(this.cards.indexOf(card), true);
        }, { signal });

        window.addEventListener('resize', () => {
          this.scheduleLayout();
        }, { signal });

        document.addEventListener('shopify:section:reorder', () => {
          this.scheduleLayout();
        }, { signal });

        this.observer = new ResizeObserver(() => this.scheduleLayout());
        this.observer.observe(this.viewport);
        this.observer.observe(this.cards[0]);

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
          }, { threshold: 0.05 });

          this.visibilityObserver.observe(this.viewport);
        }

        this.alignRight();
        this.build();
      }

      alignRight() {
        const target = Array.from(document.querySelectorAll('.krcmf__inner'))
          .find(node =>
            this.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING
          );

        if (this.alignmentTarget !== target) {
          if (this.alignmentTarget) {
            this.observer?.unobserve(this.alignmentTarget);
          }

          this.alignmentTarget = target;

          if (target) this.observer?.observe(target);
        }

        if (!target || !target.getBoundingClientRect().width) {
          this.style.removeProperty('--krt-aligned-right');
          return;
        }

        const edge = Math.max(
          0,
          this.getBoundingClientRect().right -
          target.getBoundingClientRect().right
        );

        const value = edge.toFixed(2) + 'px';

        if (this.style.getPropertyValue('--krt-aligned-right') !== value) {
          this.style.setProperty('--krt-aligned-right', value);
        }
      }

      scheduleLayout() {
        cancelAnimationFrame(this.layoutFrame);

        this.layoutFrame = requestAnimationFrame(() => {
          if (!this.isConnected || !this.cards?.length) return;

          this.alignRight();

          const signature = [
            this.viewport.clientWidth,
            this.cards[0].getBoundingClientRect().width.toFixed(2)
          ].join(':');

          if (signature !== this.sizeSignature) this.build();
        });
      }

      makeClone(card) {
        const clone = card.cloneNode(true);

        clone.dataset.trainingClone = 'true';
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('data-training-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.classList.remove('is-active', 'is-playing');

        clone.querySelectorAll('[id]').forEach(node => {
          node.removeAttribute('id');
        });

        clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => {
          node.removeAttribute('data-shopify-editor-block');
        });

        clone.querySelectorAll('video, [data-training-play]').forEach(node => {
          node.remove();
        });

        return clone;
      }

      build() {
        if (!this.count) return;

        clearTimeout(this.scrollTimer);
        this.queue = [];
        this.moving = false;
        this.targetPhysical = null;
        this.pauseVideos();

        this.track.querySelectorAll('[data-training-clone]').forEach(node => {
          node.remove();
        });

        const width = this.cards[0].getBoundingClientRect().width;
        if (!width || !this.track.clientWidth) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const stride = width + gap;

        this.buffer = 0;
        this.track.style.justifyContent = this.count === 1 ? 'center' : '';

        if (this.count > 1) {
          const groups = Math.max(
            1,
            Math.ceil(
              (this.track.clientWidth / 2 + stride) /
              (this.count * stride)
            )
          );

          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();

          for (let group = 0; group < groups; group++) {
            this.cards.forEach(card => {
              before.append(this.makeClone(card));
              after.append(this.makeClone(card));
            });
          }

          this.buffer = groups * this.count;
          this.track.prepend(before);
          this.track.append(after);
        }

        this.slides = Array.from(this.track.children);

        this.sizeSignature = [
          this.viewport.clientWidth,
          this.cards[0].getBoundingClientRect().width.toFixed(2)
        ].join(':');

        this.instantAt(this.buffer + this.index, () => this.syncVideos());
      }

      position(slide) {
        const cardRect = slide.getBoundingClientRect();
        const trackRect = this.track.getBoundingClientRect();

        return this.track.scrollLeft +
          cardRect.left +
          cardRect.width / 2 -
          trackRect.left -
          this.track.clientLeft -
          this.track.clientWidth / 2;
      }

      nearest() {
        const rect = this.track.getBoundingClientRect();
        const center = rect.left + this.track.clientLeft + this.track.clientWidth / 2;

        let nearest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const cardRect = slide.getBoundingClientRect();
          const nextDistance = Math.abs(
            cardRect.left + cardRect.width / 2 - center
          );

          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });

        return nearest;
      }

      instantAt(physical, callback) {
        const slide = this.slides?.[physical];
        if (!slide) return;

        clearTimeout(this.scrollTimer);
        cancelAnimationFrame(this.jumpFrame);

        this.jumping = true;
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft = this.position(slide);

        this.jumpFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;

          this.track.style.removeProperty('scroll-snap-type');
          this.jumping = false;
          callback?.();
        });
      }

      step(direction) {
        if (this.count < 2) return;

        this.queue.push(direction > 0 ? 1 : -1);
        this.runQueue();
      }

      runQueue() {
        if (
          this.jumping ||
          this.moving ||
          this.dragging ||
          !this.queue.length
        ) return;

        const direction = this.queue.shift();
        this.moveTo(this.buffer + this.index + direction);
      }

      moveTo(physical, instant = false) {
        const slide = this.slides?.[physical];
        if (!slide) return;

        this.moving = true;
        this.targetPhysical = physical;
        this.moveStarted = performance.now();
        this.pauseVideos();

        if (instant || this.reduced.matches) {
          this.track.scrollTo({
            left: this.position(slide),
            behavior: 'instant'
          });

          this.finish(true);
          return;
        }

        this.track.scrollTo({
          left: this.position(slide),
          behavior: 'smooth'
        });

        this.scheduleFinish(500);
      }

      goTo(index, instant = false) {
        this.queue = [];
        this.dragging = false;
        this.moveTo(this.buffer + index, instant);
      }

      scheduleFinish(delay) {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.finish(), delay);
      }

      finish(force = false) {
        if (
          !this.isConnected ||
          this.jumping ||
          this.dragging ||
          !this.slides?.length
        ) return;

        let physical = this.nearest();

        if (this.moving && this.targetPhysical != null) {
          const target = this.slides[this.targetPhysical];

          if (target) {
            const distance = Math.abs(
              this.position(target) - this.track.scrollLeft
            );

            if (
              !force &&
              distance > 2 &&
              performance.now() - this.moveStarted < 1200
            ) {
              this.scheduleFinish(100);
              return;
            }

            physical = this.targetPhysical;
          }
        }

        const logical = Number(
          this.slides[physical].dataset.trainingIndex
        );

        this.index = Number.isFinite(logical) ? logical : 0;

        this.instantAt(this.buffer + this.index, () => {
          this.moving = false;
          this.targetPhysical = null;
          this.syncVideos();
          this.runQueue();
        });
      }

      pauseVideos() {
        this.cards?.forEach(card => {
          card.querySelector('video')?.pause();
          card.classList.remove('is-playing');
          this.updateButton(card);
        });
      }

      updateButton(card) {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-training-play]');

        if (!video || !button) return;

        const paused = video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', String(!paused));
        button.setAttribute(
          'aria-label',
          paused ? this.dataset.playLabel : this.dataset.pauseLabel
        );
      }

      syncVideos() {
        if (!this.cards) return;

        this.cards.forEach((card, index) => {
          const active = index === this.index;
          const video = card.querySelector('video');
          const button = card.querySelector('[data-training-play]');

          card.classList.toggle('is-active', active);
          card.inert = !active;
          card.setAttribute('aria-hidden', String(!active));

          if (button) button.hidden = !active;
          if (!video) return;

          const shouldPlay =
            active &&
            this.inView &&
            !document.hidden &&
            !this.dragging &&
            !this.moving &&
            !this.userPaused.has(index) &&
            (!this.reduced.matches || this.manualStarted.has(index));

          if (!shouldPlay) {
            video.pause();
            card.classList.remove('is-playing');
            this.updateButton(card);
            return;
          }

          if (!video.paused) {
            this.updateButton(card);
            return;
          }

          const promise = video.play();

          if (promise?.catch) {
            promise.catch(() => {
              card.classList.remove('is-playing');
              this.updateButton(card);
            });
          }
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.jumpFrame);
        clearTimeout(this.scrollTimer);

        this.controller?.abort();
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.pauseVideos();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".sticky-features");
    const wrapper = document.querySelector(".sticky-features_content-wrapper");
    const oddBlocks = document.querySelectorAll(".sticky-features_odd-col .sticky-features_feature-block");
    const evenBlocks = document.querySelectorAll(".sticky-features_even-col .sticky-features_feature-block");

    if (!section || !wrapper) return;

    let blocks = [];
    const maxLength = Math.max(oddBlocks.length, evenBlocks.length);
    for (let i = 0; i < maxLength; i++) {
      if (oddBlocks[i]) blocks.push(oddBlocks[i]);
      if (evenBlocks[i]) blocks.push(evenBlocks[i]);
    }

    const totalSteps = blocks.length;
    const windowH = window.innerHeight;
    if (window.innerWidth >= 768) {
      section.style.height = `${windowH * (totalSteps + 1)}px`;
    } else {
      section.style.height = "auto";
    }

    if (blocks[0]) {
      blocks[0].style.opacity = 1;
      blocks[0].style.transform = "translateY(0)";
      blocks[0].style.zIndex = 2;
    }

    const images = document.querySelectorAll(".sticky-features_featured-image");
    if (images[0]) {
      images[0].classList.add("active");
    }

    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY;
      const sectionTop = section.offsetTop;
      let sectionScroll = scrollY - sectionTop;

      if (sectionScroll < 0) sectionScroll = 0;

      if (sectionScroll <= windowH * totalSteps) {
        let step = Math.floor(sectionScroll / windowH);
        step = Math.max(0, Math.min(step, totalSteps - 1));
        const progress = (sectionScroll % windowH) / windowH;

        if (window.innerWidth > 575) {
          images.forEach((img, i) => {
            img.classList.toggle("active", i === step);
          });
        } else {
          if (progress > 0.5) {  
            images.forEach((img, i) => {
              img.classList.toggle("active", i === step);
            });
          }
        }

        blocks.forEach((block, i) => {
          if (i === step) {
            let translateY = windowH - (progress * 2 * windowH);
            let opacity;
            if (window.innerWidth <= 575) {
              opacity = 1;
            } else {
              if (i === 0) {
                if (progress < 0.7) {
                  opacity = 1;
                  translateY = 0;
                } else {
                  opacity = 1 - (progress - 0.7) / 0.4;
                  translateY = -(progress - 0.7) * windowH;
                }
              } else {
                if (progress < 0.4) {
                  opacity = progress / 0.4;
                } else if (progress > 0.7) {
                  opacity = 1 - (progress - 0.7) / 0.4;
                } else {
                  opacity = 1;
                }
              }
            }

            block.style.opacity = opacity;
            block.style.transform = `translateY(${translateY}px)`;
            block.style.zIndex = 2;
          } else {
            block.style.opacity = 0;
            block.style.transform = `translateY(${windowH}px)`;
            block.style.zIndex = 1;
          }
        });
      }
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".sticky-features_feature-block-mobile");
    const images = document.querySelectorAll(".sticky-features_featured-image-mobile");

    if (!cards.length || !images.length) return;

    images.forEach((img, i) => {
      img.style.display = i === 0 ? "block" : "none";
    });

    if (cards[0]) {
      cards[0].classList.add("active-card");
    }

    cards.forEach((card, index) => {
      card.addEventListener("click", () => {
        images.forEach(img => (img.style.display = "none"));

        cards.forEach(c => c.classList.remove("active-card"));

        if (images[index]) {
          images[index].style.display = "block";

          images[index].scrollIntoView({
            behavior: "smooth",
            block: "center" 
          });
        }

        card.classList.add("active-card");
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
